import type { FaireProductEntity } from "../../entity_types/product";

export const p_77gfe3u9by: FaireProductEntity = {
  token: "p_77gfe3u9by",
  type: "product",
  name: "Rose Botanica Limited Edition Candle",
  brandToken: "b_b5fb0344",
  brandName: "Brooklyn Candle Studio",
  imageUrl:
    "https://cdn.faire.com/fastly/b35d46db437a5e8230f47d67bf7ddf154117541cbb4a2084ce33333d60a7d7f7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/94c4b3ad49c9cf845deca64b43609d3c2f4f8e60d262025788b450de9601674d.jpeg",
    "https://cdn.faire.com/fastly/071a99b3164d1f69725151b145765d30880ff416eadbf89b092ab43792fbc128.jpeg",
    "https://cdn.faire.com/fastly/977fcb030f561a305cdadc6191173b7a76669ba42fea72311105639ab81dbc34.jpeg",
  ],
  priceDollars: 18,
  description:
    "LIMITED EDITION pink matte screenprinted candle. Packaged in a textured box with a floral, rose image inspired by vintage graphic posters.\n\nThis item is available while supplies last.\n\nA downtown take on your classic rose, this candle finds soft floral notes striking a perfect balance with subtle hints of musk and sandalwood.",
  tags: [],
  msrpDollars: 36,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:34.635Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
